import {
  fetchArchivedAppointments,
  fetchArchivedAppointmentsListIdsAndCursor
} from 'modules/queues/Archive/actions/fetchArchivedAppointments';
import {
  fetchAppointments,
  fetchAppointmentsListIdsAndCursor as fetchPatientAppointmentsListIdsAndCursor,
} from 'modules/queues/Schedule/actions/fetchAppointments';

export const fetchAppointmentsByQueueType = () => (dispatch, getState) => {
  const { isArchiveOpened } = getState().queues.common.appointmentInfo;

  return isArchiveOpened
    ? dispatch(fetchArchivedAppointments())
    : dispatch(fetchAppointments());
};


export const fetchAppointmentsListIdsAndCursor = () => (dispatch, getState) => {
  const { isArchiveOpened } = getState().queues.common.appointmentInfo;

  return isArchiveOpened
    ? dispatch(fetchArchivedAppointmentsListIdsAndCursor())
    : dispatch(fetchPatientAppointmentsListIdsAndCursor());
};

